import { useModuleDetails } from "modules/moduleTemplates/components/ModuleDetailsDrawer/context";
import { useGeneralData } from "modules/moduleTemplates/components/ModuleDetailsDrawer/stores/useGeneralData";
import { type FC } from "react";
import OneCardBlockForm from "./components/OneCardBlockForm";

const OneCardBlockConfig: FC = () => {
  const { oneCardsLoadingQueries } = useModuleDetails();
  const { contentBlocks } = useGeneralData();

  if (!contentBlocks || !contentBlocks.length) {
    return null;
  }

  return (
    <>
      {contentBlocks.map((item, index) => (
        <OneCardBlockForm
          key={index}
          item={item}
          index={index}
          isLoadingFile={oneCardsLoadingQueries[index]}
        />
      ))}
    </>
  );
};

export default OneCardBlockConfig;
